import React, { Component } from 'react';
import Loader from "../utils/Loader";
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { withRouter } from '../utils/withRouter';
import { connect } from "react-redux";
import { BASE_URL, toastError } from '../utils/constants';
import { getCmsContent_action } from '../actions/cms_action/cmsAction';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            scrollPosition: 0,
            cmsMode: '',
            headerNavs: [],
            UserID: localStorage.getItem("UserID"),
            RoleID: localStorage.getItem("RoleID"),
            cmsSubheaderData: [],
            govtLogoList: [],
            downloadUrl: '',
            overflowItems: []
        };
        this.onLogout = this.onLogout.bind(this);
        this.navLogin = this.navLogin.bind(this);
        this.handleMenuOverflow = this.handleMenuOverflow.bind(this);
    }

    componentDidMount() {
        // Inject CSS for left-side submenu inside More menu (so you don't have to edit external CSS)
        const css = `
            /* Only inside More menu: make nested submenu open to left */
            #moreMenu .sub-menu .menu-item-has-children > .sub-menu,
            #moreMenu .menu-item-has-children > .sub-menu {
                left: auto !important;
                right: 100% !important;
                top: 0 !important;
            }
            /* Flip arrow (if your theme uses pseudo element) */
            #moreMenu .menu-item-has-children > a::after {
                transform: rotate(360deg);
            }
            /* Ensure More menu is above others */
            #moreMenu { z-index: 9999; }
            #moreMenu .sub-menu { min-width: 200px; }
        `;
        this.styleEl = document.createElement('style');
        this.styleEl.type = 'text/css';
        this.styleEl.appendChild(document.createTextNode(css));
        document.head.appendChild(this.styleEl);

        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });
        this.handleScroll = () => {
            this.setState({ scrollPosition: window.scrollY });
        };
        if (Array.isArray(this.props.headerNavs) && this.props.headerNavs.length > 0) {
            this.setState({ headerNavs: this.props.headerNavs }, () => {
                setTimeout(() => this.handleMenuOverflow(), 50);
            });
        } else {
            console.log('else header')
            this.getCmsContent(1, 'home');
        }
        const path = this.props.location.pathname;
        const cmsPrefix = '/cms';
        if (path.includes(cmsPrefix)) {
            this.setState({ cmsMode: 1 })
        } else {
            this.setState({ cmsMode: 0 })
        }
        window.addEventListener('scroll', this.handleScroll);

        $(document).ready(function () {
            $(".offcanvas__close, .offcanvas__overlay").on("click", function () {
                $(".offcanvas__info").removeClass("info-open");
                $(".offcanvas__overlay").removeClass("overlay-open");
            });

            $(".navigate__close, .offcanvas__overlay").on("click", function () {
                $(".offcanvas__info").removeClass("info-open");
                $(".offcanvas__overlay").removeClass("overlay-open");
            });

            $(".sidebar__toggle").on("click", function () {
                $(".offcanvas__info").addClass("info-open");
                $(".offcanvas__overlay").addClass("overlay-open");
            });

            $(".body-overlay").on("click", function () {
                $(".offcanvas__area").removeClass("offcanvas-opened");
                $(".df-search-area").removeClass("opened");
                $(".body-overlay").removeClass("opened");
            });

            $('#mobile-menu-toggle').on('click', function () {
                $('#mobile-menu').toggleClass('open');
            });
        });
        setTimeout(() => this.handleMenuOverflow(), 300);
        window.addEventListener("resize", this.handleMenuOverflow);
    }

    componentDidUpdate(prevProps, prevState) {
        // If headerNavs changed (fetched or updated), recalc overflow
        if (prevState.headerNavs !== this.state.headerNavs || prevState.cmsMode !== this.state.cmsMode) {
            // give React time to render nodes before measurement
            setTimeout(() => this.handleMenuOverflow(), 50);
        }

        // If props.headerNavs is provided by parent and changed, update local state
        if (this.props.headerNavs !== prevProps.headerNavs && Array.isArray(this.props.headerNavs)) {
            this.setState({ headerNavs: this.props.headerNavs });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener("resize", this.handleMenuOverflow);
        if (this.styleEl && this.styleEl.parentNode) this.styleEl.parentNode.removeChild(this.styleEl);
    }
    getCmsContent = async (MenuID, MenuUrl) => {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    headerNavs: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
                    govtLogoList: data?.data[6] !== "" ? data?.data[6] : [],
                }, () => {
                    // measure again after setting navs
                    setTimeout(() => this.handleMenuOverflow(), 50);
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    // core overflow logic — collects data-id and puts overflow IDs into state
    handleMenuOverflow = () => {
        const nav = document.getElementById("mainMenu");
        if (!nav) return;

        const moreMenu = document.getElementById("moreMenu");
        const items = [...nav.children].filter(li => li.id !== "moreMenu");

        moreMenu.classList.add("d-none");
        let overflowItems = [];
        items.forEach(li => li.classList.remove("d-none"));

        let navWidth = nav.offsetWidth - 120;
        let totalWidth = 0;

        items.forEach(li => {
            const id = li.getAttribute("data-id");
            totalWidth += li.offsetWidth;

            if (totalWidth > navWidth) {
                moreMenu.classList.remove("d-none");
                if (id) overflowItems.push(id);
                li.classList.add("d-none");
            }
        });

        // 🔥 FORCE ADD INTERNAL PAGES if they exist in data
        const cmsEnabled = localStorage.getItem("isVerified");
        const internalPagesExist = this.state.headerNavs.some(n => !n.isMenuItem);

        // 🔥 FORCE ADD CMS ROOT when user is verified
        if (cmsEnabled) {
            if (internalPagesExist) {
                if (!overflowItems.includes("internal-pages")) {
                    overflowItems.push("internal-pages");
                }
            }
            if (!overflowItems.includes("cms-root")) {
                overflowItems.push("cms-root");
            }
        }

        this.setState({ overflowItems: [...new Set(overflowItems)] });
    };


    onLogout() {
        localStorage.clear();
        this.props.navigate('/');
    }

    navLogin() {
        sessionStorage.setItem('isLoginClicked', true);
        this.props.navigate('/login');
    }
    handleMenuClick(MenuID, Url, Title) {
        if (Title == 'Visitor Registration') {
            return;
        } else {
            localStorage.setItem("MenuID", MenuID);
            localStorage.setItem("Url", Url);

            const trimmedUrl = (Url || '').trim();
            const externalUrlPattern = /^(https?:\/\/|www\.|ftp:\/\/|mailto:)/i;

            if (externalUrlPattern.test(trimmedUrl)) {
                // open external links in new tab
                window.open(trimmedUrl, '_blank');
            } else {
                const normalizedUrl = trimmedUrl.startsWith('/') ? trimmedUrl : '/' + trimmedUrl;
                const basePath = this.props.location.pathname.includes('/cms') ? '/cms/manage' : '';
                // keep your previous behavior (constructed path)
                const newPath = `${basePath}${normalizedUrl}&${MenuID}`

                this.props.navigate(newPath);
            }
        }
    }

    render() {
        const { isLoading, headerNavs, cmsMode, cmsSubheaderData, govtLogoList, downloadUrl, overflowItems } = this.state;

        return (
            <>
                {isLoading && <Loader />}
                <header>
                    {/* === Top Header === */}
                    <div className="tg-header__top">
                        <div className="container custom-container">
                            <div className="row align-items-center">
                                {cmsSubheaderData?.length > 0 && (
                                    <>
                                        <div className="col-lg-4">
                                            <div className="tg-header__top-menu">
                                                <ul className="list-wrap mb-0">
                                                    {cmsSubheaderData
                                                        .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType === "SM")
                                                        .map(item => {
                                                            let iconClass = '';
                                                            let href = item.Link;

                                                            switch (item.SocialType) {
                                                                case 'Email':
                                                                    iconClass = 'fas fa-envelope';
                                                                    href = `mailto:${item.Link}`;
                                                                    break;
                                                                case 'Phone':
                                                                    iconClass = 'fas fa-phone';
                                                                    href = `tel:${item.Link}`;
                                                                    break;
                                                                case 'Instagram':
                                                                    iconClass = 'fab fa-instagram';
                                                                    break;
                                                                case 'Facebook':
                                                                    iconClass = 'fab fa-facebook-f';
                                                                    break;
                                                                case 'LinkedIn':
                                                                    iconClass = 'fab fa-linkedin-in';
                                                                    break;
                                                                case 'Twitter':
                                                                    iconClass = 'fab fa-twitter';
                                                                    break;
                                                                case 'Youtube':
                                                                    iconClass = 'fab fa-youtube';
                                                                    break;
                                                                default:
                                                                    iconClass = '';
                                                            }

                                                            // Ensure other links have https:// if not mailto or tel
                                                            const isSpecialLink = href.startsWith('mailto:') || href.startsWith('tel:');
                                                            if (!isSpecialLink && !/^https?:\/\//i.test(href)) {
                                                                href = `https://${href}`;
                                                            }

                                                            return (
                                                                <li key={item.SubheaderID}>
                                                                    <a href={href} target="_blank" rel="noopener noreferrer"
                                                                        className="d-flex align-items-center gap-2 flex-wrap flex-md-nowrap">

                                                                        {iconClass && (
                                                                            <i className={`${iconClass}`} style={{ fontSize: "14px" }} />
                                                                        )}

                                                                        <span style={{ fontSize: "10px" }}>
                                                                            {item.SubheaderName}
                                                                        </span>
                                                                    </a>

                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="tg-header__top-social text-end">
                                                <marquee
                                                    style={{ fontSize: "16px", color: "#fff", fontWeight: "500" }}
                                                    behavior="scroll"
                                                    direction="left"
                                                    scrollamount="5"
                                                    onMouseOver={(e) => e.target.stop()}
                                                    onMouseOut={(e) => e.target.start()}
                                                >
                                                    <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                                                </marquee>
                                            </div>
                                        </div>

                                        {/* ViewType: BTN (Buttons) */}
                                        <div className="col-lg-2">
                                            <div className="tg-header__top-social text-end">
                                                {cmsSubheaderData
                                                    .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType == "BTN")
                                                    .map(item => (
                                                        <a key={item.SubheaderID}
                                                            className="btn-blinker border mt-1 p-1 px-3 rounded-4 fw-normal d-inline-block me-2"
                                                            href={item.Link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ fontSize: "14px" }}
                                                        >
                                                            {item.SubheaderName}
                                                        </a>
                                                    ))}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* === Sticky Header === */}
                    <div id="header-fixed-height" />

                    <div id="sticky-header" className="tg-header__area" style={{ padding: '10px', paddingTop: '30px' }}>
                        <div className="container custom-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="tgmenu__wrap">
                                        {govtLogoList?.length && govtLogoList.filter((data) => data.isActive == 1 && data.isPublish == 1).length > 0 ? <>
                                            {/* GOVT LOGO (separate row above nav) */}
                                            <div className="govt_logo text-end mb-2 d-flex justify-content-end align-items-center">
                                                {govtLogoList.length > 0 ? 'Supported By' : ''}
                                                {govtLogoList?.length > 0 &&
                                                    govtLogoList
                                                        .filter((data) => data.isActive == 1 && data.isPublish == 1)
                                                        .map((logo, index) => {
                                                            const imgSrc = logo.GovtLogoFilepath
                                                                ? `${downloadUrl}/${logo.GovtLogoFilepath.replace(/\\/g, "/")}`
                                                                : "https://via.placeholder.com/150x80?text=Logo";

                                                            const imgElement = (
                                                                <img
                                                                    key={index}
                                                                    src={imgSrc}
                                                                    alt="Govt Logo"
                                                                    style={{ height: "40px", marginLeft: "10px" }}
                                                                />
                                                            );

                                                            return logo.Link ? (
                                                                <a key={index} target="_blank" href={logo.Link} rel="noopener noreferrer">
                                                                    {imgElement}
                                                                </a>
                                                            ) : (
                                                                imgElement
                                                            );
                                                        })}
                                            </div>
                                        </> : <></>}
                                        <nav className="tgmenu__nav container-fluid">
                                            <div className="row align-items-center">
                                                {/* Left Column - Logo (10%) */}
                                                <div className="col-2 col-md-2 d-flex justify-content-start">
                                                    <div className="logo">
                                                        <Link to="/">
                                                            <img src="assets/img/logo_2.png" alt="Logo" />
                                                        </Link>
                                                    </div>
                                                </div>

                                                {/* Center Column - Menu (80%) */}
                                                <div className="col-8 col-md-9">
                                                    <div className="tgmenu__navbar-wrap tgmenu__main-menu d-flex justify-content-center">
                                                        <ul className="navigation d-flex align-items-center justify-content-center gap-1 flex-nowrap" id="mainMenu">

                                                            {/* Editor Home */}
                                                            {localStorage.getItem('isVerified') && (
                                                                <li key={'editor-home'} data-id={'editor-home'}>
                                                                    <a style={{ fontSize: '13px' }}>
                                                                        <Link to="/cms/manage">Editor Home</Link>
                                                                    </a>
                                                                </li>
                                                            )}

                                                            {/* Dynamic Menu Code */}
                                                            {(() => {
                                                                const internalPages = [];
                                                                const filteredNavs = headerNavs?.filter(item => item.isActive && item.isPublish) || [];
                                                                const parents = filteredNavs?.filter(item => item.ParentID === null) || [];
                                                                const childrenMap = {};

                                                                filteredNavs?.forEach(item => {
                                                                    if (item.ParentID !== null) {
                                                                        if (!childrenMap[item.ParentID]) childrenMap[item.ParentID] = [];
                                                                        childrenMap[item.ParentID].push(item);
                                                                    }
                                                                });

                                                                const menuItems = parents?.sort((a, b) => a.Sequence - b.Sequence)?.map((parent) => {
                                                                    const hasChildren = (childrenMap[parent.MenuID] || []).length > 0;
                                                                    const showMenu = parent.isMenuItem || (hasChildren && (childrenMap[parent.MenuID] || []).some(child => child.isMenuItem));

                                                                    if (!showMenu && cmsMode) internalPages.push(parent);

                                                                    if (hasChildren) {
                                                                        return (
                                                                            <li key={parent.MenuID} data-id={parent.MenuID} className="menu-item-has-children for-cms">
                                                                                <a style={{ fontSize: '13px' }}>{parent.Title}</a>
                                                                                <ul className="sub-menu">
                                                                                    {childrenMap[parent.MenuID]?.sort((a, b) => a.Sequence - b.Sequence)?.map(child => {
                                                                                        if (!child.isMenuItem && cmsMode) {
                                                                                            internalPages.push(child);
                                                                                            return null;
                                                                                        }
                                                                                        return (
                                                                                            <li key={child.MenuID} data-id={child.MenuID} className={`${(child.Title == 'Visitor Registration') ? 'visitor_header_footer_click' : ''}`}>
                                                                                                <a onClick={() => {
                                                                                                    this.handleMenuClick(child.MenuID, child.Url, child.Title)
                                                                                                }} style={{ fontSize: '13px' }}>
                                                                                                    {child.Title}
                                                                                                </a>
                                                                                            </li>
                                                                                        );
                                                                                    })}
                                                                                </ul>
                                                                            </li>
                                                                        );
                                                                    }

                                                                    return showMenu ? (
                                                                        <li key={parent.MenuID} data-id={parent.MenuID}>
                                                                            <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url)} style={{ fontSize: '13px' }}>
                                                                                {parent.Title}
                                                                            </a>
                                                                        </li>
                                                                    ) : null;
                                                                });

                                                                if (cmsMode && internalPages.length > 0) {
                                                                    menuItems.push(
                                                                        <li key="internal-pages" data-id="internal-pages" className="menu-item-has-children for-cms">
                                                                            <a style={{ fontSize: '13px' }}>Internal Pages</a>
                                                                            <ul className="sub-menu">
                                                                                {internalPages.map((item) => (
                                                                                    <li key={item.MenuID} data-id={item.MenuID}>
                                                                                        <a onClick={() => this.handleMenuClick(item.MenuID, item.Url)} style={{ fontSize: '13px' }}>
                                                                                            {item.Title}
                                                                                        </a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </li>
                                                                    );
                                                                }

                                                                return menuItems;
                                                            })()}

                                                            {/* CMS Menu */}
                                                            {localStorage.getItem('isVerified') && (
                                                                <li key={'cms-menu'} data-id={'cms-root'} className="menu-item-has-children for-cms">
                                                                    <a style={{ fontSize: '13px' }}>CMS</a>
                                                                    <ul className="sub-menu">
                                                                        <li data-id="cms-manage"><Link to="/cms/manage">Switch to Editor Mode</Link></li>
                                                                        <li data-id="cms-header"><Link to="/cms/header">Menu Settings</Link></li>
                                                                        <li data-id="cms-logout" onClick={() => this.onLogout()}><a>Logout</a></li>
                                                                    </ul>
                                                                </li>
                                                            )}

                                                            {/* MORE MENU HOLDER */}
                                                            <li id="moreMenu" className={`menu-item-has-children ${overflowItems && overflowItems.length ? '' : 'd-none'}`}>
                                                                <a style={{ fontSize: "13px" }}>More</a>
                                                                <ul className="sub-menu">
                                                                    {overflowItems.map(id => {
                                                                        // Special roots
                                                                        if (id === "cms-root") {
                                                                            return (
                                                                                <li key="cms-root" className="menu-item-has-children left-side" data-id="cms-root">
                                                                                    <a style={{ fontSize: "13px" }}>CMS</a>
                                                                                    <ul className="sub-menu sub-left">
                                                                                        <li data-id="cms-manage"><Link to="/cms/manage">Switch to Editor Mode</Link></li>
                                                                                        <li data-id="cms-header"><Link to="/cms/header">Menu Settings</Link></li>
                                                                                        <li data-id="cms-logout" onClick={() => this.onLogout()}><a>Logout</a></li>
                                                                                    </ul>
                                                                                </li>
                                                                            );
                                                                        }

                                                                        // INTERNAL PAGES IN MORE
                                                                        if (id === "internal-pages") {
                                                                            const internalPages = headerNavs.filter(n => !n.isMenuItem);

                                                                            return (
                                                                                <li key="internal-pages" className="menu-item-has-children left-side" data-id="internal-pages">
                                                                                    <a style={{ fontSize: "13px" }}>Internal Pages</a>
                                                                                    <ul className="sub-menu sub-left">
                                                                                        {internalPages.map(p => (
                                                                                            <li key={`ip-${p.MenuID}`} data-id={p.MenuID}>
                                                                                                <a onClick={() => this.handleMenuClick(p.MenuID, p.Url)}>
                                                                                                    {p.Title}
                                                                                                </a>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </li>
                                                                            );
                                                                        }

                                                                        // Fallback: normal menu item (could be parent or child)
                                                                        const item = headerNavs?.find(x => x.MenuID == id) || null;
                                                                        if (!item) return null;

                                                                        const children = headerNavs?.filter(x => x.ParentID == id) || [];
                                                                        const hasChildren = children.length > 0;

                                                                        if (hasChildren) {
                                                                            return (
                                                                                <li key={`more-${id}`} className="menu-item-has-children left-side" data-id={item.MenuID}>
                                                                                    <a style={{ fontSize: "13px" }}>{item.Title}</a>
                                                                                    <ul className="sub-menu sub-left">
                                                                                        {children.sort((a, b) => a.Sequence - b.Sequence).map(child => (
                                                                                            <li key={`more-child-${child.MenuID}`} data-id={child.MenuID}>
                                                                                                <a onClick={() => this.handleMenuClick(child.MenuID, child.Url, child.Title)} style={{ fontSize: "13px" }}>
                                                                                                    {child.Title}
                                                                                                </a>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </li>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <li key={`more-${id}`} data-id={item.MenuID}>
                                                                                <a onClick={() => this.handleMenuClick(item.MenuID, item.Url)} style={{ fontSize: "13px" }}>
                                                                                    {item.Title}
                                                                                </a>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>

                                                {/* Right Column - Login/Action (10%) */}
                                                <div className="col-2 col-md-1 d-flex justify-content-end">
                                                    <div className="tgmenu__action">
                                                        <ul className="list-wrap m-0">
                                                            <li>
                                                                <a href="https://india-itme.com/"
                                                                    target="_blank"
                                                                    className="btn border-btn my_login_btn login_btn_click"
                                                                    style={{ padding: '10px', marginTop: '10px' }}>
                                                                    Login
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="mobile-nav-toggler ms-3">
                                                        <i className="tg-flaticon-menu-1" />
                                                    </div>
                                                </div>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </header >

            </>
        );
    }
}

export default withRouter(connect(null, { getCmsContent_action })(Header));